// removed by extract-text-webpack-plugin
module.exports = {"paper":"_2SpcVX1_3RzBvzYrr5h7_1","noScroll":"_3iKsWVQWvcRVzFXzkHBHvj","previousIcon":"_3L732LLpNRQyvejJIEhS9y","nextIcon":"_1liwHrp3qn6L1bnYiSMr1z","closeIcon":"_1w9JTp7vkZrUb3drq3Zs0k","toolbar":"_2EN14VdBCPM6L7Zx2hnDgY","marksOpen":"_3qEIjJ9R4hrWYnkDku6iwl","marks":"R3lQ_EoyZuZKGR4XVVSSj","basicToolbarMarks":"_3R3CMiMjzqss1n6Gj8T1Gs","button":"wUY0_oCDa4mXOjFKfRLbV","pageNum":"_1skjYLOEFe97Ah5DM7BjeZ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Paper/Paper.css
// module id = 719
// module chunks = 3